import * as types from './mutation-types'
// 加载动画
// export const setLoading = function ({commit, state}, loading) {
//     console.log('state:',state)
//     commit(types.SET_LOADING, loading)
// }
export const setLoading = function ({commit}, loading) {
    commit(types.SET_LOADING, loading)
}
export const setLoginPop = function ({commit}, loginPop) {
    commit(types.SET_LOGINPOP, loginPop)
}
// 用户信息
export const setUser = function ({commit}, user) {
  commit(types.SET_USER, user)
}
// 签到数据分析eid
export const setEid = function ({commit}, eid) {
    commit(types.SET_EID, eid)
}
// 分页
export const setPage = function ({commit}, page) {
    commit(types.SET_PAGE, page)
}
// 客户端类型
export const setClientType = function ({commit}, ClientType) {
    commit(types.SET_CLIENTTYPE, ClientType)
}
// 错误提示信息
export const setErrorMsg = function ({commit}, errorMsg) {
    commit(types.SET_ERRORMSG, errorMsg)
}
// 无数据提示
export const setNoDataTip = function ({commit}, noDataTip) {
    commit(types.SET_NODATATIP, noDataTip)
}
// 无数据提示
export const setRefresh = function ({commit}, refresh) {
    commit(types.SET_REFRESH, refresh)
}
// 是否初始化
export const setIsInit = function ({commit}, isInit) {
  commit(types.SET_ISINIT, isInit)
}
// 设置是否显示报名用户选择框
export const setAaEnrollment = function ({commit}, aaEnrollment) {
  commit(types.SET_AAENROLLMENT, aaEnrollment)
}
// 刷新报名用户选择框
export const setInitAaEnrollment = function ({commit}, initAaEnrollment) {
  commit(types.SET_INITAAENROLLMENT, initAaEnrollment)
}
// 选择的报名用户列表
export const setAaEnrollmentList = function ({commit}, aaEnrollmentList) {
  commit(types.SET_INITAAENROLLMENTLIST, aaEnrollmentList)
}
// 选择的报名用户列表
export const setNowIdentity = function ({commit}, nowIdentity) {
  commit(types.SET_NOWIDENTITY, nowIdentity)
}
// 渠道id
export const setChannelid = function ({commit}, channelid) {
  commit(types.SET_CHANNELID, channelid)
}
// app提示
export const setShowAppTips = function ({commit}, showAppTips) {
  commit(types.SET_SHOWAPPTIPS, showAppTips)
}